import { SerializedStyles, css } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType, InputVariantType } from 'src/domains/layouts/config/features/types';
import { SwitchIcon } from 'src/domains/layouts/shared/assets/icons/SwitchIcon';
import { withConfig } from 'src/withConfig';

type PriceInputType = 'up' | 'down' | null;

const oddsColors = (theme: EmotionTheme, priceDirection: PriceInputType): SerializedStyles => {
    if (priceDirection === 'up') {
        return css`
            background: ${theme.star.odds.bgColor};
        `;
    }

    if (priceDirection === 'down') {
        return css`
            background: ${theme.star.odds.bgColorSecondary};
        `;
    }

    return css`
        background: ${theme.star.odds.bgColorQuaternary};
    `;
};

interface PriceInputPropsType {
    priceDirection: PriceInputType;
    variant: InputVariantType | null;
}

export const PriceInputWrapper = withConfig(theme => styled('div', { label: 'PriceInputWrapper' })<PriceInputPropsType>`
    ${({ priceDirection }): SerializedStyles => oddsColors(theme, priceDirection)};
    border-radius: ${({ variant }): string => variant === InputVariantType.SECONDARY ? theme.star.radius.small : '0'};
    align-items: center;
    color: ${theme.star.odds.txtColor};
    cursor: pointer;
    display: flex;
    flex: 0 0 66px;
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.medium};
    height: 100%;
    justify-content: center;
`);

interface OptionPropsType {
    variant: DefaultComponentVariantType | null;
}

export const Option = withConfig(theme => styled('span', { label: 'Option' })<OptionPropsType>`
    color: ${theme.star.odds.txtColor};
    line-height: 1.3334;
    font-weight: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? theme.star.fontWeight.xMedium : theme.star.fontWeight.regular};
`);

export const SwitchIconWrapper = withConfig(theme => styled(SwitchIcon, { label: 'SwitchIconWrapper' })`
    fill: ${theme.star.betslipGeneral.iconColorSwitch};
    margin-left: 4px;
    pointer-events: none;
    width: 12px;
`);
